import { createSelector } from "@reduxjs/toolkit";

import { ACTIVE, INACTIVE } from "../../consts/shiftManagerDetails";

import { shiftManagersSorterSelector } from "../sorters/selectors";

export const shiftManagerManagementLoadingSelector = (state) =>
  state.shiftManagerManagement.loading;
export const shiftManagerViewSelector = (state) =>
  state.shiftManagerManagement.shiftManagerView;

export const sectionsSelector = (state) =>
  state.shiftManagerManagement.sections;

export const shiftManagersSelector = (state) =>
  state.shiftManagerManagement.shiftManagers;
export const shiftManagerSelector = (shiftManagerCode) => (state) =>
  state.shiftManagerManagement.shiftManagers.find(
    (shiftManager) => shiftManager.shiftManagerCode === shiftManagerCode
  );

export const shiftManagerEditModeSelector = (state) =>
  !!state.shiftManagerManagement.shiftManagerEdit;
export const shiftManagerEditSelector = (state) =>
  state.shiftManagerManagement.shiftManagerEdit;
export const shiftManagerEditCopySelector = (state) =>
  state.shiftManagerManagement.shiftManagerEditCopy;
export const isShiftManagerEditValidSelector = (state) =>
  state.shiftManagerManagement.isShiftManagerEditValid;

export const shiftManagersOptionsSelector = createSelector(
  shiftManagersSelector,
  (shiftManagers) => {
    if (!shiftManagers) return [];
    return shiftManagers.map(({ shiftManagerCode, shiftManagerName }) => ({
      value: `${shiftManagerCode} - ${shiftManagerName}`,
      shiftManagerCode,
    }));
  }
);

export const shiftManagersListSelector = createSelector(
  shiftManagerViewSelector,
  shiftManagersSelector,
  (view, shiftManagers) => {
    switch (view) {
      case ACTIVE:
        return shiftManagers?.filter((shiftManager) => shiftManager.isActive);
      case INACTIVE:
        return shiftManagers?.filter((shiftManager) => !shiftManager.isActive);
      default:
        return shiftManagers;
    }
  }
);

export const reorderedShiftManagerListSelector = createSelector(
  shiftManagersListSelector,
  shiftManagersSorterSelector,
  (shiftManagers, sorter) =>
    [...(shiftManagers || [])].sort((a, b) =>
      sorter({ shiftManager: a }, { shiftManager: b })
    )
);
